import { Component } from '@angular/core';

@Component({
  templateUrl: './error.component.html',
  standalone: false
})
export class ErrorComponent {}
